import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'
import { Text } from 'blaze-ui/Text/Text'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { SearchButton } from 'blaze-components/WriterTopBar/SearchButton'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

export const BaseMobileTopBar = ({ title }: { title: string }) => {
  const theme = useHeaderTheme()

  const isAPMobileWeb = useAPMobileWeb()
  if (isAPMobileWeb) {
    return null
  }

  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        <UnlockButton />
        <SearchButton />
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center>
        <Text lineClamp={1}>{title}</Text>
      </MobileTopBarContainer.Center>
      <MobileTopBarContainer.Right />
    </MobileTopBarContainer.Root>
  )
}
